import * as React from 'react';
import { Button, Icon } from 'antd';
import { Link } from 'react-router-dom';

import { Column, DataTableView } from 'src/core/ui/data-table.view';
import { OptionsDialogView } from 'src/core/ui/options-dialog.view';

interface IDocumentTemplateListViewProps extends ComponentViewProps<DataSet<IDocumentTemplateSummary>> {
	downloadTemplate: (record: IDocumentTemplateSummary) => void;
	onItemDoubleClicked: (item: IDocumentTemplateSummary | "Document" | "Report") => any;
}

interface State {
	showModal: boolean;
}

export class DocumentTemplateListView extends React.Component<IDocumentTemplateListViewProps, State> {
	public state: State = { showModal: false };

	private columns: Column[] = [
		{
			title: 'Name',
			key: 'displayName',
			dataIndex: 'displayName',
			render: (text, record: IDocumentTemplateSummary) => <Link to={`/general/document-templates/${record.id}`}>{text}</Link>,
		},
		{
			title: 'Category',
			key: 'categoryDisplayName',
			dataIndex: 'categoryDisplayName'
		},
		{
			title: 'Usages',
			key: 'usages',
			dataIndex: 'categoryUsages'
		},
		{
			title: 'Is Document?',
			key: 'isDocument',
			dataIndex: 'isDocument',
			render: (value: boolean) => <Icon type={`${value ? 'check' : 'cross'}-circle-o`} style={{ color: value ? 'green' : 'red', fontSize: 16 }} />
		},
		{
			title: '',
			key: 'download',
			render: (value: any, record: IDocumentTemplateSummary) => {
				return <Button icon="download" onClick={() => this.props.downloadTemplate(record)} />;
			}
		}
	];

	public render(): React.ReactNode {
		if (this.props.model == null) {
			return null;
		}

		return (
			<div className="window window-normal">
				<OptionsDialogView
					closeDialog={this.closeDialog}
					options={[
						{
							key: 'Document',
							text: 'Document',
							checked: true
						},
						{
							key: 'Report',
							text: 'Report'
						}
					]}
					showDialog={this.state.showModal}
					title='Choose a type'
					subtitle='You can choose between a Document or a Report template.'
				/>
				<div className="panel">
					<DataTableView
						setBusy={this.props.setBusy}
						columns={this.columns}
						model={this.props.model}
						itemDoubleClick={this.props.onItemDoubleClicked}
						createNewItem={this.createNew}
					/>
				</div>
			</div>
		);
	}

	private createNew = () => {
		this.setState({ showModal: true });
		return Promise.resolve(null);
	}

	private closeDialog = (selectedValue?: "Document" | "Report") => {
		if (selectedValue) {
			this.props.onItemDoubleClicked(selectedValue);
		}
		this.setState({ showModal: false });
	}
}



// WEBPACK FOOTER //
// ./src/app/general/document-templates/list/document-template-list.view.tsx